export enum PromoCodeScope {
  ChannelingPartnerOnboarding = 'channeling-partner-onboarding',
}
